import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const UnsubscribeComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "UnsubscribePage" */ "@circle-react/components/Notifications/PublicNotificationPreferences"
    ),
);

export const UnsubscribePage = () => (
  <Suspense fallback={<PageLoader />}>
    <UnsubscribeComponent />
  </Suspense>
);
